import { useParams } from 'react-router';
import { useMemo } from 'react';

import { useGetContactQuery } from 'store/api/version-api.slice';

import LinkedMembers from '../components/LinkedMembers';
import { prepareMember } from '../utils';

const LinkedMembersContainer = () => {
	const { primary_member, portal_id } = useParams();

	const { data = {}, isFetching } = useGetContactQuery({
		primaryMember: primary_member,
		portalId: portal_id
	});

	const members = useMemo(() => {
		return data.linked_members?.map(member => prepareMember(member)) ?? [];
	}, [data]);

	const isAllowedToAdd = useMemo(() => {
		const limit = data.membertype?.linked_limit ?? 0;
		const current = data.linked_members?.length ?? 0;

		return current < limit;
	}, [data.linked_members?.length, data.membertype?.linked_limit]);

	return <LinkedMembers members={members} loading={isFetching} isAllowedToAdd={isAllowedToAdd} />;
};

export default LinkedMembersContainer;
